<template>
<div>
  <div>
  <vx-card v-show="isCardActiveLocal" class="mt-3">
    <div v-if="question.quizDetails.isGraded" class="vx-row">
      <div class="flex flex-wrap items-center justify-center">
        <p class="ml-4 mr-2">Score: </p>
        <vs-input type="number" :disabled="$acl.check('Monitor')" autocomplete="off" style="width: 58px;" min="0" :max="answer.questionTotalMarks != 0 ? answer.questionTotalMarks : answer.textOriginalTotalPoints != 0 ? answer.textOriginalTotalPoints : answer.tableOriginalTotalPoints != 0 ? answer.tableOriginalTotalPoints : 'N/A'" class="mr-2" size="small" :name="answer.questionId" v-model="answer.questionAchievedMarks" />
        <p class="mr-2">/</p>
        <p v-if="answer.questionTotalMarks != 0">{{ answer.questionTotalMarks }}</p>
        <p v-else-if="answer.textOriginalTotalPoints != 0">{{ answer.textOriginalTotalPoints }}</p>
        <p v-else-if="answer.tableOriginalTotalPoints != 0">{{ answer.tableOriginalTotalPoints }}</p>
      </div>
    </div>
    <div v-if="answer.lastComment" class="mt-2 vx-row">
      <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
        <label>Last Comment by {{answer.lastCommentBy}}:</label>
        <vs-textarea  id="studentComment" readOnly v-model="answer.lastComment" />
      </div>
      <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
        <div style="padding-top: 20px;">
          <vs-button color="success" class="mr-3 vs-con-loading__container" ref="viewHistoryButton" @click.stop.prevent="showCommentHistoryPopup(answer.assessmentId)">View History</vs-button>
        </div>
      </div>
    </div>
    <div class="mt-2 vx-row">
      <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
        <label>Comment:</label>
        <vs-textarea :disabled="$acl.check('Monitor')" v-model="answer.assessorComment" />
      </div>
      <div v-if="!$acl.check('Monitor')" class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
        <label>Predefined Comments:</label>
        <v-select  placeholder="Search / Select Predefined Comment" :options="predefinedComments" v-model="predCommentDropdown" @search:blur="addComment"></v-select>
      </div>
    </div>
    <!-- <div v-if="answer.moderatorComment" class="mt-2 vx-row">
      <div class="vx-col flex-1">
        <label><strong>Moderator Comment:</strong></label>
        <vs-textarea readOnly v-model="answer.moderatorComment" />
      </div>
    </div> -->
  </vx-card>
  </div>

<!-- Comments Popup -->
  <div>
    <vs-popup  ref="commentHistoryPopup" title="Comment History" :active.sync="commentHistoryPopupActive">
      <div v-if="comments.length > 0">
        <table id="commentTable" style="width: 100%;" >
          <thead>
          <tr>
            <th>Comment</th>
            <th>Created By</th>
            <th>Created On</th>
          </tr>
          </thead>
          <tbody>
          <tr class="ml-0" v-for="(item, index) in comments" :key="index">
            <td v-if="item.comment && item.comment.includes('[')">
              <div>
                {{ item.comment.split('[')[0] }}
                <div v-for="(comment,index) in  reworkComment(item.comment)" :key="index">
                  <a :href="comment" >Uploaded File</a>
                </div>
              </div>
            </td>
            <td v-else>
              {{item.comment}}
            </td>
            <!-- <div v-if="item.comment && item.comment.includes('[')">
              <td>
                <div>
                  {{ item.comment.split('[')[0] }}
                  <div v-for="(comment,index) in  reworkComment(item.comment)" :key="index">
                    <a :href="comment" >Uploaded File</a>
                  </div>
                </div>
              </td>
              
            </div> -->

            <td class="nowrap">
                {{ item.commentType  }} ({{item.createdBy}})
              </td>
              <td class="nowrap">
                {{ item.createdOn.replace("T", " ").split('.')[0] }}
              </td>
          </tr>

          </tbody>
        </table>
      </div>
      <div v-else>
        <p style="text-align-last: center;">No comments yet...</p>
      </div>
    </vs-popup>

  </div>
</div>
</template>

<script>
  import vSelect from 'vue-select'
  export default {
    components: {
      'v-select': vSelect
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      answer: {
        type: Object,
        required: false
      },
      predefinedComments: {
        type: Array,
        required: false
      }
    },
    data() {
      return {
        predCommentDropdown: 0,
        commentHistoryPopupActive: false,
        comments : []
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {

          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;

        }
      }
    },
    methods: {
      addComment() {
        var self = this;
        if(self.predCommentDropdown){
          if(self.answer.assessorComment == null){
            self.answer.assessorComment = "";
          }
          self.answer.assessorComment += self.predCommentDropdown.label + " ";
        }
      },
      showCommentHistoryPopup(assessmentId){
        var self = this;
        self.comments = [];

        var onSuccess = function (response){
          self.comments = response.data;
          self.commentHistoryPopupActive = true;
        };

        var onFinally = function(){

          };

        self.$ajaxGet(self, "QuizAssessment/GetCommentsByAssessmentId?id=" + assessmentId, onSuccess, onFinally);
      },
      reworkComment(comment){
        
        if(comment.includes("[")){
          var commentBuilder = [];
          var commentArray = comment.split("[");
          commentArray.shift();
          commentArray.forEach(element => {
            var url = element.split("]")[0];
            commentBuilder.push(url);
          });

          return commentBuilder;

        }
        else{
          return comment;
        }
      },
      openFile(url){
        window.open(url,"_blank");
      }
    },
    mounted() {
      if(this.answer && this.answer.textOriginalTotalPoints != 0 && this.answer.questionAchievedMarks == 0){
        this.answer.questionAchievedMarks = "";
      }

      if(this.answer && this.answer.tableOriginalTotalPoints != 0 && this.answer.questionAchievedMarks == 0){
        this.answer.questionAchievedMarks = "";
      }
    },
  }

</script>

<style lang="scss">
  #studentComment {
    box-shadow: 0 4px 20px 0 rgba(var(--vs-danger),0.3);
  }

  #commentHistory .vs-popup {
    min-width: 600px;
    width: auto !important;
    max-width: 65%;
    }

  #commentTable .nowrap {
      white-space: nowrap !important;
      padding-left: 10px;
      padding-right: 10px;
      text-align: left;
    }
</style>
